const CALISTA_ADVISORY_COUNTRY_URL = `${process.env.REACT_APP_CALISTA_ADVISORY_URL}/cal-cia/cia-admin/country`

const CIACountryApiUrls = {
    GET: `${CALISTA_ADVISORY_COUNTRY_URL}/get`,
    POST: `${CALISTA_ADVISORY_COUNTRY_URL}/create`,
    PUT: `${CALISTA_ADVISORY_COUNTRY_URL}/update`,
    DELETE: `${CALISTA_ADVISORY_COUNTRY_URL}/delete`
}

export default CIACountryApiUrls
